<template>
  <div v-if="products.length > 0" class="select-wrapper">
    <select
      id="sortResults"
      v-model="selected"
      class="input input-sort"
      aria-label="sortResults"
      @change="onSortChange"
    >
      <option
        v-for="option in formattedSortingTypes"
        :key="option.key || 'mostRelevant'"
        :value="option.key"
      >
        {{ option.displayName }}
      </option>
    </select>
    <i class="fas fa-chevron-down select-icon" aria-hidden="true" />
  </div>
</template>

<script>
import eventBus from '../../vue-functions/event-bus';

export default {
  name: 'SearchSortSelector',
  props: {
    products: Array,
    settings: Object,
    selectedSort: String,
    sortingTypes: Array
  },
  emits: ['filter-search', 'set-sort-by'],
  data() {
    return {
      selected: this.selectedSort || ''
    };
  },
  computed: {
    formattedSortingTypes() {
      if (!Array.isArray(this.sortingTypes)) return [];

      const typesCopy = [...this.sortingTypes];

      const mostRelevantIndex = typesCopy.findIndex((item) => item.key === 'mostRelevant');

      let mostRelevantOption = null;
      if (mostRelevantIndex !== -1) {
        mostRelevantOption = {
          ...typesCopy.splice(mostRelevantIndex, 1)[0],
          key: ''
        };
      }

      return mostRelevantOption ? [mostRelevantOption, ...typesCopy] : typesCopy;
    }
  },
  mounted() {
    eventBus.$on('sort-by-reset', this.resetSort);
  },
  beforeUnmount() {
    eventBus.$off('sort-by-reset', this.resetSort);
  },
  methods: {
    onSortChange(event) {
      const sortValue = event.target.value;
      this.selected = sortValue;

      this.$emit('set-sort-by', sortValue);
      this.$emit('filter-search');
    },
    resetSort() {
      this.selected = '';
    }
  }
};
</script>
